import {
  createTableDefinition,
  type TableDefinition,
} from '@/features/shared/components/tableSystem/tableDefinition';
import { formatUploadStatusLabel } from '@/features/uploads/formatters';
import { getChartTitle } from '@/shared/copy/charts';
import { getDetailLabel } from '@/shared/copy/details';
import type { UploadStatus } from '@flowqa/shared';

export type UploadsSortKey = 'id' | 'fileName' | 'status' | 'createdAt' | 'error';

const uploadStatuses: UploadStatus[] = [
  'queued',
  'processing',
  'completed',
  'completed_with_errors',
  'failed',
];

export const uploadsTableDefinition: TableDefinition<UploadsSortKey, UploadStatus> =
  createTableDefinition({
    title: 'Uploads',
    searchAriaLabel: 'Search uploads by file name',
    columns: [
      { field: 'id', label: 'Upload', mandatory: true, defaultVisible: true },
      { field: 'status', label: getChartTitle('status'), defaultVisible: true },
      { field: 'error', label: 'Error', defaultVisible: true },
    ],
    defaultSortKey: 'createdAt',
    defaultSortDirection: 'desc',
    sortOptions: [
      { key: 'createdAt', label: getDetailLabel('uploaded') },
      { key: 'status', label: getChartTitle('status') },
      { key: 'fileName', label: 'File' },
      { key: 'id', label: 'Upload' },
      { key: 'error', label: 'Error' },
    ],
    sortFieldMap: {
      id: 'id',
      fileName: 'fileName',
      status: 'status',
      createdAt: 'createdAt',
      error: 'error',
    },
    statusOptions: uploadStatuses.map((status) => ({
      value: status,
      label: formatUploadStatusLabel(status),
    })),
    statusFilterLabel: getChartTitle('status'),
  });
